import { useEffect, useRef } from "react";

export function useHorizontalScroll() {
   const elRef = useRef();
   useEffect(() => {
      const el = elRef.current;
      if (el) {
         const onWheel = e => {
            if (e.deltaY === 0) return;
            el.scrollTo({
               left: el.scrollLeft + e.deltaY,
               // behavior: "smooth"
            });
         };
         el.addEventListener("wheel", onWheel, { passive: true });
         return () => el.removeEventListener("wheel", onWheel);
      }
   }, []);
   return elRef;
}
